import { render, staticRenderFns } from "./ReportTabDatasource.vue?vue&type=template&id=4460eb2a&lang=pug"
import script from "./ReportTabDatasource.vue?vue&type=script&lang=js"
export * from "./ReportTabDatasource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4460eb2a')) {
      api.createRecord('4460eb2a', component.options)
    } else {
      api.reload('4460eb2a', component.options)
    }
    module.hot.accept("./ReportTabDatasource.vue?vue&type=template&id=4460eb2a&lang=pug", function () {
      api.rerender('4460eb2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/components/ReportTabDatasource.vue"
export default component.exports